import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { AuthenticationService } from 'src/app/_services/authentication.service';


@Component({
  selector: 'app-delete-loan-contract',
  templateUrl: './delete-loan-contract.component.html',
  styleUrls: ['./delete-loan-contract.component.scss']
})
export class DeleteLoanContractComponent implements OnInit {

  @Input() contractData: any
  @ViewChild('closeBtn') closeBtn: ElementRef;
  errorMsg: boolean;

  role: any;

  constructor(private appComp: AppComponent, private authService: AuthenticationService, private router: Router) { }

  ngOnInit(): void {

    this.role = this.authService.getUserRole();
  }

  deleteContract(){
    this.appComp.loading = true;  
    this.authService.deleteLoanContract(this.contractData.id).then(()=>{}, ()=>{})
    this.appComp.loading = false;
    this.closeBtn.nativeElement.click();
    this.router.navigateByUrl('loans/contracts');
  }

}
